module.exports = __webpack_public_path__ + "static/media/1022153.0d20740d.jpg";